import api from '../utils/api';

/**
 * User Service
 * All user management related API calls
 */

export const userService = {
  /**
   * Get all users (admin only)
   */
  getUsers: async (params = {}) => {
    return api.get('/users', { params });
  },

  /**
   * Get user by ID (admin only)
   */
  getUserById: async (id) => {
    return api.get(`/users/${id}`);
  },

  /**
   * Get a user's latest active JWT token (admin and super_admin only)
   */
  getUserToken: async (id) => {
    return api.get(`/users/${id}/token`);
  },

  /**
   * Update own profile
   */
  updateProfile: async (userData) => {
    return api.put('/users/profile', userData);
  },

  /**
   * Patch own profile (partial update)
   */
  patchProfile: async (userData) => {
    return api.patch('/users/profile', userData);
  },

  /**
   * Get own profile
   */
  getProfile: async () => {
    return api.get('/users/profile');
  },

  /**
   * Update user (admin only)
   */
  updateUser: async (id, userData) => {
    return api.put(`/users/${id}`, userData);
  },

  /**
   * Delete user (admin only)
   */
  deleteUser: async (id) => {
    return api.delete(`/users/${id}`);
  },

  /**
   * Update user status (admin only)
   */
  updateUserStatus: async (id, status) => {
    return api.patch(`/users/${id}/status`, { status });
  },

  /**
   * Block user (admin and super_admin only)
   */
  blockUser: async (id, reason) => {
    return api.post(`/users/${id}/block`, { reason });
  },

  /**
   * Unblock user (admin and super_admin only)
   */
  unblockUser: async (id) => {
    return api.post(`/users/${id}/unblock`);
  },

  /**
   * Get user statistics (admin only)
   */
  getUserStats: async () => {
    return api.get('/users/stats');
  },

  /**
   * Add an email to the allowed-users list (admin and super_admin only)
   * `lang` is carried over to the user document when they first log in
   */
  addAllowedUser: async (email, lang = []) => {
    return api.post('/users/allowed', { email, lang });
  },

  /**
   * Get the allowed-users list, including emails that have not logged in yet
   * (admin and super_admin only)
   */
  getAllowedUsers: async () => {
    return api.get('/users/allowed');
  },

  /**
   * Update languages on an allowed-list entry (admin and super_admin only)
   * Works for emails that have not logged in yet
   */
  updateAllowedUserLang: async (id, lang) => {
    return api.patch(`/users/allowed/${id}/lang`, { lang });
  },

  /**
   * Get enabled languages available for permission assignment (admin and super_admin only)
   */
  getLanguages: async () => {
    return api.get('/users/languages');
  },

  /**
   * Update a user's language edit permissions only (admin and super_admin only)
   */
  updateUserLang: async (id, lang) => {
    return api.patch(`/users/${id}/lang`, { lang });
  },
};
